module.exports = __webpack_public_path__ + "img/ppt.929c74dc.png";